import { createReducer, on } from '@ngrx/store';
import {
  selectAchievement,
  updateAchievements,
} from './achievement-management.actions';
import { AchievementManagementState } from '../../interface/ngrxInterfaces/achievement-management.state';

export const initialAchievementsState: AchievementManagementState = {
  achievementsList: [],
  selectedAchievementId: null,
};

export const achievementSelectedReducer = createReducer(
  initialAchievementsState,
  on(selectAchievement, (state, { achievementId }) => ({
    ...state,
    selectedAchievementId: achievementId,
  })),
  on(updateAchievements, (state, { achievements }) => ({
    ...state,
    achievementsList: [...achievements],
  }))
);
